import { render, staticRenderFns } from "./immoCarouselBig.vue?vue&type=template&id=4caa6ef1&scoped=true&"
import script from "./immoCarouselBig.vue?vue&type=script&lang=js&"
export * from "./immoCarouselBig.vue?vue&type=script&lang=js&"
import style0 from "./immoCarouselBig.vue?vue&type=style&index=0&id=4caa6ef1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4caa6ef1",
  null
  
)

export default component.exports